/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  RangeController,
  ChoiceBoxController,
  SelectController,
  InputLineController,
  ButtonLineController,
} from '../../../controllers/Base';
import { fontOptions } from '../../../../../options';

const GridControllers = ({
  handle,
  config,
  extend,
  setExtend,
  isGlobalFontActive,
}) => (
  <>
    <ControllersGroup title="Grid" id="axis" extend={extend} setExtend={setExtend}>
      <ChoiceBoxController
        label="Formato do grid"
        handle={handle}
        kWord="GridShapeControl"
        options={[
          { label: 'Circular', value: 'circular', id: 'circular' },
          { label: 'Poligonal', value: 'linear', id: 'linear' },
        ]}
        configValue={config?.GridShapeControl}
        fullWidth
      />
      <RangeController
        label="Número de níveis"
        handle={handle}
        kWord="GridLevelControl"
        configValue={config?.GridLevelControl?.value}
        min={1}
        max={12}
        fullWidth
      />
      <RangeController
        label="Distância das categorias"
        handle={handle}
        kWord="GridLabelOffsetControl"
        configValue={config?.GridLabelOffsetControl?.value}
        min={0}
        max={60}
        fullWidth
      />
      <SelectController
        label="Fonte"
        handle={handle}
        kWord="AxisGlobalFontFamily"
        options={fontOptions}
        text={config?.UseGlobalFont !== false && isGlobalFontActive ? 'Utilizando fonte global' : ''}
        configValue={config?.AxisGlobal?.fontFamily}
        disabled={(
          config?.UseGlobalFont !== false && isGlobalFontActive
        )}
        fullWidth
      />
      <InputLineController
        label="Tamanho"
        handle={handle}
        kWord="AxisGlobalFontSize"
        configValue={config?.AxisGlobal?.fontSize}
        min={1}
        max={30}
        step={1}
        precision={0}
        isNumber
      />
      <ButtonLineController
        handle={handle}
        fontColorVal={config?.AxisGlobal?.color || '#333333'}
        fontColorKWord="AxisGlobalFontColor"
      />
      <RangeController
        label="Rotação"
        handle={handle}
        kWord="AxisRotationControl"
        configValue={config?.AxisRotationControl}
        min={-180}
        max={180}
        fullWidth
      />
      <RangeController
        label="Posição horizontal"
        handle={handle}
        kWord="AxisTranslateX"
        configValue={config?.AxisTranslateX}
        min={-500}
        max={500}
        fullWidth
      />
      <RangeController
        label="Posição vertical"
        handle={handle}
        kWord="AxisTranslateY"
        configValue={config?.AxisTranslateY}
        min={-500}
        max={500}
        fullWidth
      />
    </ControllersGroup>
  </>
);

GridControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  isGlobalFontActive: PropTypes.bool,
};

export default GridControllers;
